import { Combobox, makeStyles, mergeClasses, Option, OptionOnSelectData, SelectionEvents } from '@fluentui/react-components';
import React from 'react';
import { IWhitePaperColumn } from '../../../model';

export interface EntitySelectorComboboxProps {
    reportColumns: IWhitePaperColumn[];
    onOptionSelect: (event: SelectionEvents, data: OptionOnSelectData) => void;
    selectedOptions: string[];
    value: string;
    disabled: boolean;
    listboxStyle?: React.CSSProperties;
}

const useStyles = makeStyles({
    listbox: {
        maxHeight: '250px !important',
        overflowY: 'auto',
    },
    combobox: {
        width: '100%',
    },
});

const EntitySelectorCombobox: React.FC<EntitySelectorComboboxProps> = ({
    reportColumns,
    onOptionSelect,
    selectedOptions,
    value,
    disabled,
}) => {
    const { listbox, combobox } = useStyles();
    return (
        <Combobox
            data-testid='entity-combobox'
            onOptionSelect={onOptionSelect}
            selectedOptions={selectedOptions}
            className={mergeClasses(combobox)}
            value={value}
            input={{ className: combobox }}
            disabled={disabled}
            listbox={{
                className: listbox,
            }}
        >
            {reportColumns.map((column) => (
                <Option
                    key={`${column.columnId}${column.originalColumnIndex}`}
                    value={column.columnId?.toString()}
                    text={column.description ?? ''}
                >
                    {column.description}
                </Option>
            ))}
        </Combobox>
    );
};

export default EntitySelectorCombobox;
